/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useNoteSettingsContext } from '../note-settings/note-settings-context'
import { NoteInfoEntry } from './note-info-entry'
import React from 'react'
import { People as IconPeople } from 'react-bootstrap-icons'

/**
 * Renders an info line about the number of contributors for the note.
 */
export const NoteInfoLineContributors: React.FC = () => {
  const contributors = useNoteSettingsContext().info.editedBy.length

  return (
    <NoteInfoEntry titleI18nKey={'editor.noteInfo.contributors'} icon={IconPeople}>
      {contributors}
    </NoteInfoEntry>
  )
}
